// extracted by mini-css-extract-plugin
module.exports = {"btnTopo":"SolicitacaoDeColeta_btnTopo__3NAP3","content":"SolicitacaoDeColeta_content__3wx0F","th_tr_Responsive":"SolicitacaoDeColeta_th_tr_Responsive__2Vhi9"};